import type { RouteSectionProps } from "@solidjs/router";
import { A } from "@solidjs/router";
import { Show } from "solid-js";

import { Menu } from "~/components";

import { useRIASApp } from "~/_context/UserProvider";

const PublicLayout = (props: RouteSectionProps) => {
	const { isLoggedIn } = useRIASApp();

	return (
		<div class="min-h-screen bg-gray-100 text-gray-900">
			<header class="flex flex-col items-center justify-center min-h-20 bg-white border-gray-400 shadow-md">
				<div class="flex flex-col md:flex-row container mx-auto px-4 md:px-0 py-4 justify-between items-center">
					<A href="/" class="text-xl font-semibold tracking-tight">
						<img
							src="/images/rias-horizontal.svg"
							alt="RIAS-regs"
							class="w-auto h-[3.5vh]"
						/>
					</A>

					<nav class="flex flex-col md:flex-row pt-5 md:py-1 pl-4 grow space-x-4">
						<Show when={!isLoggedIn()}>
							<A href="/registration/" class="font-semibold py-2">
								Register for Membership
							</A>
						</Show>

						<Menu
							caption="The Scheme"
							items={[
								{ caption: "About the Scheme", href: "/about-the-scheme" },
								{ caption: "Guidance Documents", href: "/guidance-documents/" },
								{ caption: "Definitions", href: "/definitions/" },
								{ caption: "Design Certifiers", href: "/design-certifiers/" },
							]}
						/>

						<Menu
							caption="Membership"
							items={[
								{ caption: "Membership Criteria", href: "/membership-criteria" },
								{ caption: "Common Questions", href: "/membership-faqs/" },
								{ caption: "Terms & Conditions", href: "/terms-and-conditions/" },
							]}
						/>

						<A href="/contact-us/" class="font-semibold py-2">
							Contact Us
						</A>

						<A
							href={isLoggedIn() ? "/dashboard" : "/login/"}
							class="text-blue-600 font-semibold py-2">
							{isLoggedIn() ? "Dashboard" : "Sign in"}
						</A>
					</nav>
				</div>
			</header>

			<main class="container mx-auto py-12 px-6 grid grid-cols-12 gap-4">
				{props.children}
			</main>
		</div>
	);
};

export default PublicLayout;
